import {
    CREATE_STYLE_DETAIL_FAILURE,
    CREATE_STYLE_DETAIL_REQUEST,
    CREATE_STYLE_DETAIL_SUCCESS,
    CREATE_USER_FORM_STYLE_DETAIL,
    DELETE_STYLE_DETAIL_FAILURE,
    DELETE_STYLE_DETAIL_REQUEST,
    DELETE_STYLE_DETAIL_SUCCESS,
    FETCH_STYLE_DETAIL_FAILURE,
    FETCH_STYLE_DETAIL_REQUEST,
    FETCH_STYLE_DETAIL_SUCCESS,
    FETCH_SINGLE_STYLE_DETAIL_FAILURE,
    FETCH_SINGLE_STYLE_DETAIL_REQUEST,
    FETCH_SINGLE_STYLE_DETAIL_SUCCESS,
    STYLE_DETAIL_USERFORM_RESET,
    UPDATE_STYLE_DETAIL_FAILURE,
    UPDATE_STYLE_DETAIL_REQUEST,
    UPDATE_STYLE_DETAIL_SUCCESS,
    STYLE_DETAIL_USERFORM_DROPDOWNLIST_RESET,
    NAVIGATE_STYLE_DETAILS,
    NAVIGATE_STYLE_MASTER,
    FETCH_STYLE_DETAIL_BY_ID_REQUEST,
    FETCH_STYLE_DETAIL_BY_ID_SUCCESS,
    FETCH_STYLE_DETAIL_BY_ID_FAILURE,
    UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_REQUEST,
    UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_SUCCESS,
    UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_FAILURE,
    UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_SUCCESS,
    FETCH_STYLE_DETAIL_UPLOAD_IMAGES_SUCCESS,
    FETCH_STYLE_DETAIL_UPLOAD_IMAGES_REQUEST,
    FETCH_STYLE_DETAIL_UPLOAD_IMAGES_FAILURE,
    RESET_UPLOAD_IMAGES_DATA
} from './styleDetail.actionsType';

export const STYLE_DETAIL = 'styleDetail';

let initialState = {
    loading: false,
    styleDetailList: [],
    styleDetailListById: [],
    userform: {},
    pcsWeightForm: '',
    selectedStyle: {},
    errorMessage: ''
};

export let styleDetailReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STYLE_DETAIL_REQUEST:
        case FETCH_STYLE_DETAIL_BY_ID_REQUEST:
        case CREATE_STYLE_DETAIL_REQUEST:
        case UPDATE_STYLE_DETAIL_REQUEST:
        case UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_REQUEST:
        case FETCH_SINGLE_STYLE_DETAIL_REQUEST:
        case DELETE_STYLE_DETAIL_REQUEST:
        case FETCH_STYLE_DETAIL_UPLOAD_IMAGES_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STYLE_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                styleDetailList: updatePayload
            };
        case FETCH_STYLE_DETAIL_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                styleDetailListById: updatePayload
            };
        case CREATE_STYLE_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedStyle: {}
            };
        case FETCH_STYLE_DETAIL_UPLOAD_IMAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                previousImage: updatePayload
            }
        case RESET_UPLOAD_IMAGES_DATA:
            return {
                ...state,
                loading: false,
                previousImage: null
            }
        case UPDATE_STYLE_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedStyle: {}
            };
        case UPDATE_STYLE_DETAIL_FROM_STYLE_FABRIC_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedFabricGetList: updatePayload
            }
        case UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                pcsWeightForm: updatePayload
                // styleDetailListById: [...state.styleDetailListById, payload]
            };
        case FETCH_SINGLE_STYLE_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case DELETE_STYLE_DETAIL_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_STYLE_DETAIL_FAILURE:
        case CREATE_STYLE_DETAIL_FAILURE:
        case UPDATE_STYLE_DETAIL_FAILURE:
        case UPDATE_STYLE_DETAIL_FROM_STYLE_PREPARATIONS_FAILURE:
        case FETCH_SINGLE_STYLE_DETAIL_FAILURE:
        case DELETE_STYLE_DETAIL_FAILURE:
        case FETCH_STYLE_DETAIL_BY_ID_FAILURE:
        case FETCH_STYLE_DETAIL_UPLOAD_IMAGES_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_STYLE_DETAIL:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case STYLE_DETAIL_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                pcsWeightForm: ''
            };
        case STYLE_DETAIL_USERFORM_DROPDOWNLIST_RESET:
            return {
                ...state,
                userform: { ...state.userform, BuyName: '' }
            };

        case NAVIGATE_STYLE_DETAILS: {
            return {
                ...state,
                isStyleMaster: true,
                styleMasterId: payload.styleMasterId
            };
        }
        case NAVIGATE_STYLE_MASTER: {
            return {
                ...state,
                isStyleMaster: false
            };
        }
        default:
            return state;
    }
};
